window.PH = window.PH || {};

PH.filters = {
  active: null,

  categories: [
    {
      id: 'caballero',
      label: '🖤 Caballero',
      tag: 'caballero'
    },
    {
      id: 'dama',
      label: '❤️ Dama',
      tag: 'dama'
    },
    {
      id: 'nicho',
      label: '💎 Nicho',
      tag: 'nicho'
    },
    {
      id: 'arabes',
      label: '🏜️ Árabes',
      tag: 'arabes'
    },
    {
      id: 'unisex',
      label: '🤍 Unisex',
      tag: 'unisex'
    }
  ]
};